import type { TenantTeacherProp } from '@/api/bsl/tenant/user/teacher/prop';

const CACHE_KEY = 'teacher-props';

export function getTeacherPropCache(
  userKey: string
): TenantTeacherProp[] | null {
  const value = sessionStorage.getItem(CACHE_KEY);
  if (!value) return null;
  const cache = JSON.parse(value);
  return cache.userKey === userKey ? cache.props : null;
}

export function setTeacherPropCache(
  userKey: string,
  props: TenantTeacherProp[]
) {
  sessionStorage.setItem(CACHE_KEY, JSON.stringify({ userKey, props }));
}

export function clearTeacherPropCache() {
  sessionStorage.removeItem(CACHE_KEY);
}
